import { ListResultV2 } from '@xemplo/gp-types';

import { LookupRow } from './lookups-query-v2.types';

export const selectLookupData = <T extends LookupRow>(data: ListResultV2<T>) => {
  const lookupItems = data.result?.rows.map((row) => ({
    key: row.id,
    value: row.value,
  }));
  return { ...data, parsedItems: lookupItems };
};
